import ProductsRoute from './ProductsRoute';

export default {
  name: 'ProductsRoute',
  location: '/products',
  component: ProductsRoute,
};
